export const FIRST_GRANULAR_YEAR = 2025;
export const PROMOTION_YEAR_WINDOW = 5;
export const EARLIEST_PROMOTION_AGGREGATE_YEAR = 2021; 